import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

class SdsError extends PureComponent {

  render() {
    const { msg } = this.props;

    if (!Boolean(msg)) {
      return null;
    }

    return (
      <SdsDivStyled className="sds-form-group sds-block sds-block--error" >
        <p className="sds-p sds-color-error">
          {msg}
        </p>
      </SdsDivStyled>
    );
  }
}

export const SdsDivStyled = styled.div`
  background-color:  ${(props) => props.theme.colors.dangerLight} !important;
  border: 1px solid ${(props) => props.theme.colors.dangerLightBorder} !important;
  p{
    color: ${(props) => props.theme.colors.danger} !important;
  }
`;

SdsError.propTypes = {
  msg: PropTypes.string,
};

export default SdsError;
